import 'reflect-metadata'
import { defineNuxtPlugin, navigateTo } from '#app'
import { DITokens } from '@/di'
import type { DependencyContainer } from 'tsyringe'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('vue:error', (err) => {
    if (err instanceof Error) {
      const route = nuxtApp._route

      if (typeof err.cause === 'object' && err.cause !== null) {
        let statusCode = 'statusCode' in err.cause && typeof err.cause.statusCode === 'number' ? err.cause.statusCode : 503

        // FIXME
        if (statusCode === 403) {
          navigateTo({ path: '/signin', query: { redirectTo: route.fullPath } })
          return
        }
      }

      // BFF error
      if ('status' in err && 'data' in err) {
        if (err.status === 401) {
          const { $container } = nuxtApp
          if ($container) {
            const toastStore = ($container as DependencyContainer).resolve(DITokens.ToastStore)
            if (toastStore) {
              toastStore.setToast({
                mode: 'error',
                message: '認証期限切れ。再度ログインしてください。'
              })
            }
          }
          // FIXME
          navigateTo({ path: '/signin', query: { redirectTo: route.fullPath } })
          return
        }
      }
    }
  })
})
